import { render, staticRenderFns } from "./EditWorkstationScreenPage.vue?vue&type=template&id=3412b7dc"
import script from "./EditWorkstationScreenPage.vue?vue&type=script&lang=js"
export * from "./EditWorkstationScreenPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports